import { memo } from "react";

import { TireSetLocationFormProps } from "./types";
import { Badge } from "ui/components/Badge";
import WarehouseLocationForm from "./components/WarehouseLocationForm/WarehouseLocationForm";

const TireSetLocationForm: React.FC<TireSetLocationFormProps> = (props) => {
    const { formValues, setFormValues, errors, setErrors, registerValidator } = props;

    // Ako je set na vozilu — readonly prikaz
    if (formValues.vehicle?.id) {
        return (
            <div className="px-4 py-4 space-y-4">
                <div className="border border-slate-200 rounded-sm p-5">
                    <div className="flex items-center gap-4">
                        {formValues.vehicle.defaultImage && (
                            <img
                                src={formValues.vehicle.defaultImage}
                                alt={formValues.vehicle.name ?? ""}
                                className="h-14 w-14 object-contain rounded-full border border-slate-200"
                            />
                        )}
                        <div>
                            <div className="flex items-center gap-2 mb-1">
                                <span className="text-sm font-semibold text-slate-800">
                                    {formValues.vehicle.name}
                                </span>
                                <Badge text="Montirano na vozilo" variant="success" height="small" />
                            </div>
                            {formValues.vehicle.registrationPlate && (
                                <span className="text-sm text-slate-500">
                                    {formValues.vehicle.registrationPlate}
                                </span>
                            )}
                        </div>
                    </div>
                    <p className="text-xs text-slate-400 mt-3">
                        Za premještaj seta guma koristite opciju Transfer.
                    </p>
                </div>
            </div>
        );
    }

    // Novi set ili set na skladištu — odabir skladišta
    return (
        <div className="px-4 py-4 space-y-4">
            <WarehouseLocationForm
                formValues={formValues}
                setFormValues={setFormValues}
                errors={errors}
                setErrors={setErrors}
                registerValidator={registerValidator}
            />
        </div>
    );
};

export default memo(TireSetLocationForm);
